<app-dialog [loading]="isLoading" class="meter-data-info-dialog">
  <ng-container dialog-content>
    <div class="description">{{ 'module.meterReading.consumptionAndGenerationText' | translate }}</div>
    <div class="energytypes-icons">
      <div class="energytypes-left">
        <table aria-describedby="energy-types">
          <th scope="sonarqubefix" class="sonarqubefix"></th>
          <tr *ngFor="let item of energyTypes | slice : 0 : energyTypes.length / 2; let i = index">
            <td class="img-container"><img alt="energy-type-img" src="./assets/icons/{{ item?.imageName }}" /></td>
            <td class="img-title">{{ item?.name }}</td>
          </tr>
        </table>
      </div>
      <div class="energytypes-right">
        <table aria-describedby="energy-types">
          <th scope="sonarqubefix" class="sonarqubefix"></th>
          <tr *ngFor="let item of energyTypes | slice : energyTypes.length / 2 : energyTypes.length; let i = index">
            <td class="img-container"><img alt="energy-type-img" src="./assets/icons/{{ item?.imageName }}" /></td>
            <td class="img-title">{{ item?.name }}</td>
          </tr>
        </table>
      </div>
    </div>

    <hr />

    <div class="metertypes-icons">
      <div class="metertypes">
        <table aria-describedby="meter-types">
          <th scope="sonarqubefix" class="sonarqubefix"></th>
          <tr *ngFor="let item of meterTypes">
            <td class="img-container"><app-svg-icon src="./assets/icons/{{ getMeterTypeImage(item?.code) }}"></app-svg-icon></td>
            <td class="img-title">{{ item?.name }}</td>
          </tr>
        </table>
      </div>
      <div class="metertypes">
        <table aria-describedby="meter-types">
          <th scope="sonarqubefix" class="sonarqubefix"></th>
          <tr>
            <td class="img-container"><span class="fa fa-arrow-down" aria-hidden="true"></span></td>
            <td class="img-title">{{ meterDirection[0] }}</td>
          </tr>
          <tr>
            <td class="img-container"><span class="fa fa-arrow-up" aria-hidden="true"></span></td>
            <td class="img-title">{{ meterDirection[1] }}</td>
          </tr>
        </table>
      </div>
    </div>

    <div class="info-modal" *ngIf="!!remoteReadingCount">
      <app-svg-icon src="./assets/icons/{{ getMeterTypeImage('MT_RLM') }}"></app-svg-icon>
      <span>{{ 'module.energyGuard.infoDialog.remoteLegend' | translate }}</span>
    </div>
  </ng-container>
</app-dialog>
